import React, { useEffect, useState } from "react";
import Navigation from "../Components/Navigation/Navigation";
import "../Testimonials/Testimonials.css";
import Footer from "../Components/Navigation/Footer";
import Banner from "../Components/Banner";
import EstateBuilding from "../Assets/Images/Banner/testimonials.jpg";
import TestimonialModal from "./TestimonialModal";

const API_URL =
  "https://featurable.com/api/v1/widgets/82ebafb5-8f43-409c-8cfd-510b68b25707";
const MAX_LENGTH = 180;

const Testimonials = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedReviews, setExpandedReviews] = useState({});

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const reviewsPerPage = 15; // Number of testimonials per page

  // State for the Testimonial Modal
  const [isTestimonialModalOpen, setIsTestimonialModalOpen] = useState(true); // Open by default

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(API_URL);
        const data = await response.json();
        console.log("Testimonials Data:", data);

        if (data.success && data.reviews) {
          setReviews(data.reviews);
          setTotalPages(Math.ceil(data.reviews.length / reviewsPerPage)); // Calculate total pages
        } else {
          throw new Error("No reviews found");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  // Paginate reviews based on the current page
  const paginateReviews = () => {
    const startIndex = (currentPage - 1) * reviewsPerPage;
    const paginatedReviews = reviews.slice(startIndex, startIndex + reviewsPerPage);
    return paginatedReviews;
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <span key={i} className="star">
        {i < rating ? "★" : "☆"}
      </span>
    ));
  };

  const formatReviewerName = (fullName) => {
    const nameParts = fullName.split(" ");
    if (nameParts.length > 1) {
      return `${nameParts[0]} ${nameParts[1][0]}.`;
    }
    return nameParts[0];
  };

  const toggleReadMore = (reviewId) => {
    setExpandedReviews((prev) => ({
      ...prev,
      [reviewId]: !prev[reviewId],
    }));
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return; // Prevent invalid page number
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    document.title = "Testimonials | Zen Homes";
  }, []);

  return (
    <div className="testimonialsContainer">
      <Navigation linkColor="black" submenuColor="black" menuIconColor="black"/>
      <Banner title="Testimonials" backgroundImage={EstateBuilding} />

      {/* Pass the state down to the TestimonialModal */}
      <TestimonialModal
        isOpen={isTestimonialModalOpen} // Control modal visibility
        onClose={() => setIsTestimonialModalOpen(false)} // Close modal
      />

      {/* Header Section */}
      <div className="testimonialHeaderContainer">
        <button className="writeReviewBtn">
          <a
            href="https://g.page/r/CWxwm92LW980EBM/review"
            target="_blank"
            rel="noopener noreferrer"
          >
            Write a Review
          </a>
        </button>
      </div>

      {/* Reviews Section */}
      <div className="testimonialCardContainer">
        {loading && <p>Loading testimonials...</p>}
        {error && <p className="error-message">Error: {error}</p>}
        {!loading && !error && reviews.length === 0 && (
          <p>No reviews available.</p>
        )}

        {paginateReviews().map((review) => {
          const isExpanded = expandedReviews[review.reviewId];
          const shouldTruncate = review.comment.length > MAX_LENGTH;
          const reviewText =
            isExpanded || !shouldTruncate
              ? review.comment
              : `${review.comment.slice(0, MAX_LENGTH)}`;

          return (
            <div className="reviewCard" key={review.reviewId}>
              <div className="quoteIcon">
                <img
                  src="./quoteicons.png"
                  alt="Quote Icon"
                  className="quoteImg"
                />
              </div>

              {/* Review Text */}
              <p className="reviewText">
                {reviewText}
                {shouldTruncate && !isExpanded && "... "}
                {shouldTruncate && (
                  <button
                    onClick={() => toggleReadMore(review.reviewId)}
                    className="readMoreBtn"
                  >
                    {isExpanded ? "Read Less" : "Read More"}
                  </button>
                )}
              </p>

              {/* Rating Stars */}
              <div className="rating">{renderStars(review.starRating)}</div>

              {/* User Information */}
              <div className="userInfo">
                <div className="userDetails">
                  <h4 className="username">
                    {formatReviewerName(review.reviewer.displayName)}
                  </h4>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </button>
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index + 1}
            onClick={() => handlePageChange(index + 1)}
            className={currentPage === index + 1 ? "active" : ""}
          >
            {index + 1}
          </button>
        ))}
        <button
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>

      <Footer />
    </div>
  );
};

export default Testimonials;
